import { defineStore } from 'pinia'
import { useEzioAPI } from '@ezio/services'
import type { SearchResult, SearchResultType } from './types'

export const useSearchStore = defineStore('search', () => {
    const { api } = useEzioAPI()

    const search = async (query: string, types: SearchResultType[], agencyId?: string | number | null): Promise<SearchResult[]> => {
        const params: Record<string, string> = {
            q: query,
            types: types.join(',')
        }
        if (agencyId != null) params.agency_id = String(agencyId)
        const response = await api.get('search', params)
        return response.data as SearchResult[]
    }

    return { search }
})
